export default __webpack_public_path__ + "static/media/Mohamed.3db8c53d.png";